<ng-container *ngIf="content$ | async as content">
    <div id="banner" class="radius4">
        <div class="moduletable#">
            <img [src]="content.home.heroImage" [alt]="content.home.heroAlt || 'Plataforma Cloud'" />
        </div>
    </div>

    <div id="plans">
        <div class="moduletable home_small_banners">
            <ul>
                <li *ngFor="let b of content.home.banners">
                    <ng-container *ngIf="isInternalUrl(b.url); else externalBannerLink">
                        <a [routerLink]="b.url">
                            <img loading="lazy" [src]="b.image" [alt]="b.alt" />
                        </a>
                    </ng-container>
                    <ng-template #externalBannerLink>
                        <a [href]="b.url" target="_blank" rel="noopener noreferrer">
                            <img loading="lazy" [src]="b.image" [alt]="b.alt" />
                        </a>
                    </ng-template>
                </li>
            </ul>
        </div>
    </div>

    <div id="question">
        <app-rackeo-cta-contact></app-rackeo-cta-contact>
    </div>
</ng-container>
